<my-bill-odb-page-base-structure
  [billingDocument]="billDocument"
  [hasTopContent]="true"
  [hasCommonHeader]="true"
>
  <div
    class="rs-panel-big rs-bg-c2 rs-box-shadow"
    data-cy="myBillDeferralLandingPage"
    topContent
  >
    <h2 class="rs-tit3">
      {{ 'bills.deferral.landing.mainTitle' | translate }}
    </h2>
    <div class="row">
      <div class="small-12 medium-6 columns">
        <my-bill-deferral-rules-list></my-bill-deferral-rules-list>
        <div class="rs-me"></div>
        <div class="rs-flex-row rs-flex-dir-col-small-only">
          <div class="rs-flex-column rs-order-m2">
            <a
              class="rs-btn rs-btn-nl-so"
              (click)="onClickOnDelayPayment()"
              data-tms-event="button-click"
              data-tms-button-zone="mybill.deferral_landing"
              data-tms-button-name="confirm delay payment"
              [attr.data-tms-message-info]="billingAccountNumber"
              [attr.data-tms-context]="billDocument?.reference"
              data-cy="myBillDeferralLandingDeferButton"
              >{{ 'bills.deferral.buttons.delayPayment' | translate }}</a
            >
          </div>
          <my-bill-back-button
            [customLabel]="'bills.deferral.buttons.cancel'"
            [backButtonType]="'firstButtonWithLeftArrow'"
          ></my-bill-back-button>
        </div>
      </div>
    </div>
  </div>
</my-bill-odb-page-base-structure>
